import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeveloperBoardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"developer_board"}/>
}
